module.exports = __webpack_public_path__ + "img/avatar1.41fba897.png";